export const MESSAGE_ERROR = {
  E0001: "{attr1}メールの送信に失敗しました。送信先メールアドレス： {attr2}", // send mail
  E0002: "{attr}は必須入力項目です。", // required
  E0003: "{attr}は既に存在しています。", // exist1
  E0004: "{attr}の入力形式が異なります。", // format
  E0005: "{attr}は{num}文字以上である必要があります。", // length
  E0006: "{attr}は不正です。", // incorrect
  E0007: "{attr1}または{attr2}が正しくありません。", // invalid
  E0008:
    "アカウントが無効化されているためログインできません、管理者へご連絡下さい。", // deactivate
  E0009: "法人 / 個人区分の「法人」を選択した場合、法人番号は必須入力です。", //required corp num
  E0010: "{attr}は{num}桁の半角数字で入力してください。", // digit half-width numbers
  E0011: "有効な法人番号を入力してください。", // invalid corp num
  E0012: "{attr}はハイフンありの半角数字で入力してください。", // half-width numbers with hyphens
  E0013: "{attr}は{num}文字以上で入力してください。", // character
  E0014: "既に使用されている{attr1}です。別の{attr2}をご指定ください。", // exist2
  E0015: "該当データがありません。", // no corresponding data
  E0016: "このメソッドは許可されません。", // method is not allowed
  E0017: "管理ユーザの登録に失敗しました。", // failed to register
  E0018: "システムエラーが発生いたしました。</br>何度も発生する場合、ヘルプデスクへお問合せいただけますようお願いいたします。",
  E0019: "{attr}は半角英数字で入力してください。", // half-width alphanumeric characters
  E0020: "{attr}は全角{num1}文字(半角{num2}文字)以下で入力してください。",
  E0021: "{attr}は{num}文字以下で入力してください。",
  E0022: "0バイトのファイルはアップロード出来ません。", // smaller than the minimum file size
  E0023: "10MBを超えるファイルはアップロード出来ません。", // larger than the maximum file size
  E0025: "{attr}は、数値で入力して下さい。", // must is numerical value
  E0026: "{attr}は、数字で入力して下さい。", // must is number
  E0027:
    "JPG/PNG、PDF、CSV、Word、Excel、PowerPoint、および zip ファイルのみをアップロードできます。", // type file
  E0030: "シークレットURL送信が失敗されました。", // sending failed
  E0031: "{attr}が無効です。", // disabled
  E0032: "{attr}は特殊文字を含めることはできません。", // contain special characters
  E0040: "SMSコードは6数値である必要があります。", // numeric
  E0041: "SMSコードは間違っています。", // sms incorrect
  E0042: "メールアドレスまたはパスワードが正しくありません。", // mail - pass invalid
  E0045: "{attr}が正しくありません。正しい期間を入力してください。", // check date to
  E0046: "{attr}が正しくありません。正しい金額を入力してください。", // check amount to
  E0047: "{attr} (To）が日付ではありません。正しい日付を入力してください。", // check date to
  E0048: "{attr} (From）が日付ではありません。正しい日付を入力してください。", // check date from
  E0054: "{attr}がまだ有効化されていません。", //  account disable
  E0060: "{attr1}は{attr2}と等しくなければいけません。", //  account disable
  E0105: "{attr}は半角数字で入力してください。", //Numeric only
  E0061: "{attr}が存在しません。", //  not exist
  E0069: "一回でアップロードできるファイル数は最大{num}個です。",
  E0071: "同名のファイルはアップロード出来ません。",
  E0076: "融資希望日は当日から{num}営業日以降の日付で入力が必要です。",
  E0084: "{attr}は{min}から{max}までの範囲で入力してください。",
  E0106: "{attr}は{min}以上で入力してください。", //Number too small
  E0107: "{attr}は{max}以下で入力してください。", // Number too big
  // Invoice needs to be the same corp and tokui
  E0114: "選択した全ての請求書は入金消込未完了かつ同じいCorptIdと同じい得意名でなければなりません。",
  E0074: "選択した全ての請求書は入金消込完了でなければなりません。",
  E0075: "選択した全ての請求書は振込完了した請求書があります。再度ご確認ください。",
  E0064: "「{attr}」ファイルは空でアップロードできません。",
  E0065: "「{attr}」ファイルは10MBを超えているため、アップロードできません。",
  E0066: "「{attr}」ファイルはjpg | png | pdf | word | excel | powerpoint | zipの形式でアップロードしてください。",
  E0067: "{attr}が見つかりません。",
  E0068: "メッセージの送信に失敗しました。",
  E0080: "ファイル形式が間違っています。（アップロード可能なファイル形式：JPG/PNG、PDF、CSV、Word、Excel、PowerPoint、zip）。",
  E0081: "ファイルは10MBを超えているため、アップロードできません。",
  E0082: "ファイルは空でアップロードできません。",
  E0077: "こちら請求書の保証金を支払い完了に変更します。</br>よろしいでしょうか。",
  E0079: "選択した全ての請求書は入金消込完了でなければなりません。",
  // Must not be dated in the past
  E0117: "{attr}は過去の日付を設定できません。",
  E0083: '選択した全ての請求書は未払の請求書でなければなりません。',
  E0088: '選択した請求書は得意先により確認されることかつ早期資金化申請未実施でなければなりません。',
  E0093: "{attr}の日付が正しくありません。",
  E0086: '無効なデータが送信されています。再度ご確認ください。',
  E0099: 'メッセージを送信することができません。', // Unable to send message
  E0123: 'ユーザがこのアカウントの解約を依頼しました。', // request to cancel
  E0124: '同じメールアドレスの複数のユーザが有効になるため、変更できません。', // active user exists
  E0125: 'ユーザがこのアカウントの解約を依頼しているため、新規融資申込を登録できません。',
};

export const MESSAGE_INFO = {
  I0001: "{attr1}メールの送信に成功しました。送信先メールアドレス：{attr2}",
  I0002: "管理ユーザの登録に成功しました。",
  I0003: "メールアドレス「{attr1}」を持つ{attr2}の基本情報の変更が完了しました。",
  I0030: "シークレットURL送信が成功されました。", // sending success
  I0032: "{attr}が成功されました。", // success
  I0041: "コード認証中です、しばらくお待ちください。", // sms code verify success
  I0004: "請求書の債権保証申請が完了しました。",
  I0005: "請求書の支払期限更新が完了しました。",
  I0006: "早期資金化依頼処理が完了しました。",
};

export const MESSAGE_WARNING = {
  W0001: "管理ユーザ情報を編集しますか?",
  W0002: "一般ユーザ情報を編集しますか?",
};
type Role = {
  key: number;
  value: string;
};

export const ROLES: Role[] = [
  { key: 1, value: "管理者" }, // ADMIN
  { key: 2, value: "SWX管理ユーザ" }, // SWX_ADMIN
  { key: 3, value: "保証会社ユーザ" }, // GUARANTEE_ADMIN
  { key: 4, value: "金融機関ユーザ" }, // FINANCIAL_INSTITUTION_ADMIN
  { key: 5, value: "エンドユーザ" }, // END_USER
];

export function replaceAttr(
  message: string,
  attrs: { [key: string]: string },
): string {
  return Object.entries(attrs).reduce(
    (acc, [key, value]) => acc.replace(`{${key}}`, value),
    message,
  );
}

export const TITLE_CONTACT = "オンライン融資 No.";
export const NO_DATA = "データがありません";
export const CLICK_SORT_DESC = "降順でショート";
export const CLICK_SORT_ASC = "昇順でショート";
export const CLICK_CANCEL_SORT = "ショートをキャンセル";
export const ERR_TITLE = "エラー";
export const ERR_SELECT_RECEIPT =
  "選択した全ての請求書は入金消込未完了かつ同じいCorptIdと同じい得意名でなければなりません。";
export const CONFIRM = "確認";
export const DEPOSIT_APP = "入金消込";
export const CANCEL = "キャンセル";
export const CSV_FILE = "CSVファイル";
export const UPLOAD_FILE_COMPARE =
  "ここにファイルをドロップ<br/>またはファイルを選択する";
export const FILE_FB_EXPORT = "shiharai.txt";
export const DEPOSIT_DATE = "取組日";
export const EXPORT_FB = "FB出力";
export const ERR_SELECT_EXPORT_FB =
  "選択した請求書は入金消込完了していない請求書があります。";
export const BTN_BACK = "戻り";
export const MSG_ALERT_SUCCESS = {
  RECEIPT: "入金消込処理が完了しました。",
  GUARANTEE_PAYMENT: "債権保証状況更新処理が完了しました。",
  TRANSFER_COMPLETED: "振込状況更新処理が完了しました。",
  ERALY_CASH: "早期資金状況更新処理が完了しました。",
  GUARANTEE_REQUEST: "債権保証申請処理が完了しました。"
}
